import InfoMySecures from "./infoMySecures";

export default InfoMySecures;
